export default __webpack_public_path__ + "static/media/SEN.f71ae73b.svg";